import { render, staticRenderFns } from "./StudentAddGoods.vue?vue&type=template&id=5c102ed1&scoped=true&"
import script from "./StudentAddGoods.vue?vue&type=script&lang=js&"
export * from "./StudentAddGoods.vue?vue&type=script&lang=js&"
import style0 from "./StudentAddGoods.vue?vue&type=style&index=0&id=5c102ed1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c102ed1",
  null
  
)

export default component.exports